import {useCallback, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {apiFetch} from '../api';

function formatTimestamp(dateStr) {
    const date = new Date(dateStr);
    const now = new Date();
    const diffMs = now - date;
    const diffMin = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMin < 1) return 'Just now';
    if (diffMin < 60) return `${diffMin}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays < 7) return `${diffDays}d ago`;
    return (
        date.toLocaleDateString('en-GB', {day: 'numeric', month: 'short', year: 'numeric'}) +
        ', ' +
        date.toLocaleTimeString('en-GB', {hour: '2-digit', minute: '2-digit'})
    );
}

export default function ShareActivityLog({checklistId}) {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    const fetchActivity = useCallback(async () => {
        try {
            const res = await apiFetch(`/checklists/${checklistId}/shares/activity`);
            const data = await res.json();
            setEvents(data);
            setLoading(false);
        } catch {
            setError(true);
            setLoading(false);
        }
    }, [checklistId]);

    useEffect(() => {
        fetchActivity();
    }, [fetchActivity]);

    if (loading) {
        return <p className="share-loading">Loading activity...</p>;
    }

    if (error) {
        return <p className="share-error">Failed to load activity.</p>;
    }

    if (events.length === 0) {
        return <p className="share-empty">No activity yet.</p>;
    }

    return (
        <div className="share-activity-log">
            {events.map((event, i) => (
                <div key={event.timestamp + i} className="share-activity-event">
                    <span className="share-activity-icon" aria-hidden="true">
                        {event.type === 'first_view' ? '👁' : event.action === 'check' ? '☑' : '☐'}
                    </span>
                    <span className="share-activity-text">
                        <strong>{event.shareName}</strong>{' '}
                        {event.type === 'first_view' ? (
                            'opened their link'
                        ) : event.action === 'check' ? (
                            <>checked &ldquo;{event.itemTitle}&rdquo;</>
                        ) : (
                            <>unchecked &ldquo;{event.itemTitle}&rdquo;</>
                        )}
                    </span>
                    <span className="share-activity-time">{formatTimestamp(event.timestamp)}</span>
                </div>
            ))}
        </div>
    );
}

ShareActivityLog.propTypes = {
    checklistId: PropTypes.string.isRequired,
};
